import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import Table from '../../components/Table';
import BtnSpinner from '../../components/BtnSpinner';
import { Edit3, Trash } from 'lucide-react';
import Pagination from '../../components/Pagination';
import moment from 'moment';
import AddOrEditCoupon from './AddOrEditCoupon';
import CustomOffCanvas from '../../components/CustomOffCanvas';

function Coupons() {

  const [coupons, setCoupons] = useState(null);
  const [loading, setLoading] = useState({ state: false, name: "" });
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const [deleteId, setdeleteId] = useState(null);
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });


  const token = localStorage.getItem("token");


  const totalItems = coupons?.length; // Total number of items
  const itemsPerPage = 10;

  const currentData = coupons?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  const handleRefresh = () => setRefresh(!refresh);

  const handleSearch = async () => {
    if (!searchTerm) {
      return ErrorTost("Enter a key to serach")
    }

    if(currentPage!==1){
      setCurrentPage(1)
    }
    
    await fetchCoupons(searchTerm)
  };


  const fetchCoupons = async () => {
    setLoading({ state: true, name: 'fetchcoupons' })
    try {
      const couponRes = await Apirequests(`coupons/get-coupons?q=${searchTerm}`,
        "GET",
        {},
        {
          Authorization: `Bearer ${token}`,
        });

      // console.log(couponRes,'coupons')

      if (couponRes?.success) {
        setCoupons(couponRes?.data)
      }
    } catch (error) {
      console.log(error, 'fetch coupons error');
      return ErrorTost("Something went wrong. Try again later.")
    }
    setLoading({ state: false, name: "" })
  }

  const handleDeleteCoupon = async (couponid) => {
    setLoading({ state: true, name: "deletecoupon" });
    setdeleteId(couponid)
    try {
      const delRes = await Apirequests(`coupons/delete-coupon/${couponid}`, 'DELETE', {}, {
        Authorization: `Bearer ${token}`
      });
      if (delRes?.success) {
        SuccessTost(delRes?.message || "coupon deleted successfully");
        setRefresh((prev) => !prev);
      } else {
        ErrorTost(delRes?.message)
      }
    } catch (error) {
      console.log(error, 'delete order error');
      ErrorTost("Something went wrong, please try again later. ")
    }
    setLoading({ state: false, name: "" })
  };



  useEffect(() => {
    fetchCoupons();
  }, [refresh, token]);


  if (loading.state && loading.name === "fetchcoupons") {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <SpinningLogo />
    </div>
  }




  return (
    <div>
      <CustomPageHeader
        title={"Coupons"}
        text={searchTerm}
        setText={setSearchTerm}
        handleSearch={handleSearch}
        onClick={() => setIsOffCanvasOpen({ state: true, name: "addcoupon" })}
        btnText={"Add Coupon"}
        handleBackClick={() => navigate("/")}
        handleRefresh={handleRefresh}
        handleDownload={() => downloadExcel(coupons, 'coupons')}
      />

      <main className="mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="overflow-x-auto">
            <Table
              tableHead={

                <tr>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Coupon Code</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Coupon Title</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Discount Percentage</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Expiry Date</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Applicable Courses</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Crated At</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              }
              tableBody={
                currentData?.map((coupon, i) =>
                  <tr key={i}>
                    <td className="px-6 py-4 whitespace-nowrap">{coupon?.coupon_code}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{coupon?.coupon_title}</td>
                    <td className="px-6 py-4 whitespace-nowrap"><span className={`${coupon?.status === "Active" ? "bg-green-200" : "bg-red-200"} px-3 py-2 rounded-full`}>{coupon?.status}</span></td>
                    <td className="px-6 py-4 whitespace-nowrap">{coupon?.discount_percentage}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{moment(coupon?.expiry_date).format('DD-MM-YY')}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {
                        coupon?.include_courses?.map((c, i) =>
                          <li>{c?.course_title}</li>
                        )
                      }
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">{moment(coupon?.createdAt).format('DD-MM-YY')}</td>
                    <td className="px-6 py-4 whitespace-nowrap flex gap-3">
                      <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDeleteCoupon(coupon?._id)}>
                        {
                          loading.state && loading.name === "deletecoupon" && deleteId === coupon?._id ?
                            <BtnSpinner /> :
                            <>
                              <Trash className='text-red-700 text-sm' size={20} />
                              <span className='text-red-700 text-sm'>Delete</span>
                            </>
                        }

                      </button>

                      <button className='flex bg-gray-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editcoupon" }); setCurrentCoupon(coupon) }}><Edit3 size={18} /> Edit</button>
                    </td>
                  </tr>)
              }
            />
          </div>
        </div>
        {coupons?.length ?
          <div className="flex gap-x-2 items-center justify-between">
            <p>total: {coupons?.length}</p>
            <Pagination
              page={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div> : null}
      </main>

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addcoupon"}
        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
        content={
          <AddOrEditCoupon
            close={() => setIsOffCanvasOpen({ state: false, name: "" })}
            setRefresh={setRefresh}
            coupon={currentCoupon}
          />
        }
      />


      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editcoupon"}
        close={() => {setIsOffCanvasOpen({ state: false, name: "" });setCurrentCoupon(null)}}
        content={
          <AddOrEditCoupon
            close={() => {setIsOffCanvasOpen({ state: false, name: "" }); setCurrentCoupon(null)}}
            setRefresh={setRefresh}
            coupon={currentCoupon}
          />
        }
      />

    </div>
  )
}

export default Coupons